import type { TFunction } from "@luckymenu/i18n";
import { type NavigationModel, type TabKey, tabFallback } from "@luckymenu/staff-core";
import type { NavItem } from "@luckymenu/ui-web";
import {
	BookOpen,
	ClipboardList,
	Ellipsis,
	LayoutGrid,
	type LucideIcon,
	Receipt,
} from "lucide-react";

const TAB_ROUTES: Record<TabKey, { href: string; icon: LucideIcon }> = {
	orders: { href: "/orders", icon: ClipboardList },
	tables: { href: "/tables", icon: LayoutGrid },
	bill: { href: "/bill", icon: Receipt },
	menu: { href: "/menu", icon: BookOpen },
	more: { href: "/more", icon: Ellipsis },
};

/** Maps the shared navigation model to web routes and icons. */
export function tabItems(model: NavigationModel, t: TFunction<"nav">): NavItem[] {
	return model.tabs.map((tab) => ({
		key: tab.key,
		label: t(tab.labelKey as "orders"),
		...TAB_ROUTES[tab.key],
	}));
}

export function activeTab(pathname: string): string | undefined {
	return pathname.split("/")[1] || "orders";
}

/**
 * Where to go instead when the address is a tab the plan or role does not
 * have (P10-T04: a menu-only plan has no Orders, Tables or Bill): the first
 * tab there is. Null when the address is fine.
 */
export function tabRedirect(model: NavigationModel, pathname: string): string | null {
	const fallback = tabFallback(model, activeTab(pathname));
	return fallback ? TAB_ROUTES[fallback].href : null;
}
